var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.open,"width":"480"}},[_c('v-card',[_c('v-card-title'),_c('v-card-text',[_vm._t("default")],2),_c('v-card-actions',[_c('v-spacer'),_c('TextButton',{on:{"click":_vm.onClick}},[_vm._v("OK")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }